export const StatusDespesa = {
    CRIADA: 0,
    AGUARDANDO_APROVACAO_DEMANDANTE: 1,
    REPROVADA_POR_DEMANDANTE: 2,
    AGUARDANDO_APROVACAO_GERENTE: 3,
    REPROVADA_POR_GERENTE: 4,
    APROVADA: 5,
    CANCELADA: 6,
    REPROVADA_PELA_UABS: 7
}
